import { hasAccessTokenSelector } from '@/redux/auth/selectors';
import {
  ROUTE_DEPRECATED_USER_PORTFOLIOS,
  ROUTE_DISCOVER_SAMPLE_PORTFOLIOS,
} from '@/constants/routes';
import { redirect } from 'redux-first-router';

export const redirectPortfolioHome = (location, currentState) => {
  const hasAccessToken = hasAccessTokenSelector(currentState);
  return redirect({
    type: hasAccessToken
      ? ROUTE_DEPRECATED_USER_PORTFOLIOS
      : ROUTE_DISCOVER_SAMPLE_PORTFOLIOS,
  });
};
